import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const TransfusionsPage = lazy(() => import('@/pages/transfusions/ui/index'))

export const Route = createFileRoute('/_protected/recipients/transfusions/')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <TransfusionsPage />
    </Suspense>
  ),
})
